/**
 * OfflinePendingChip — Plan 04-03 / UI-SPEC §"<OfflinePendingChip />".
 *
 * Small terracotta-soft Pill with WifiOff icon and "Sendes når du er online
 * igjen". Rendered inline on `<ItemRow>` while a mutation is queued in the
 * SW Workbox queue (Plan 04-04). T-04-09 mitigation: the message uses
 * "Sendes når du er online igjen" (informational), never "Failed to send".
 *
 * #157 (redesign steg 7d): skissens nøytrale «Venter på nett»-etikett
 * (`bg-track`), fortsatt med WiFi-ikonet og fortsatt bare informasjon.
 */
import { useTranslation } from 'react-i18next';
import { Icon } from '../../components/primitives/Icon';
import { Pill } from '../../components/primitives/Pill';

interface OfflinePendingChipProps {
  className?: string;
}

export function OfflinePendingChip({ className }: OfflinePendingChipProps) {
  const { t } = useTranslation();
  return (
    <span
      data-testid="shopping-offline-pending"
      aria-label={t('shopping.pending.chip')}
      className={className}
    >
      <Pill variant="neutral" className="whitespace-nowrap">
        <Icon.WifiOff size={12} />
        {t('shopping.pending.chip')}
      </Pill>
    </span>
  );
}
